export const getYotpoParams = (locales: string[], locale: string) => {
    const localeIndex = locales.findIndex((configuredLocale) => configuredLocale.includes(locale));
    const yotpoAppId = process.env.NEXT_PUBLIC_YOTPO_APP_ID?.split(",")[localeIndex];
    const yotpoInstanceId = process.env.NEXT_PUBLIC_YOTPO_INSTANCE_ID?.split(",")[localeIndex];

    return {
        yotpoAppId,
        yotpoInstanceId,
        yotpoEnabled: [yotpoAppId, yotpoInstanceId].every((id) => !!id && id !== "null"),
    };
};
